import React from "react";
import { Switch, Tag } from "antd";

/** روابط التواصل الاجتماعي داخل خلية الجدول */
export const socialLink = (url, icon) =>
  url ? (
    <a
      className="color-inherit text-decoration-none py-1 px-2 d-block"
      target="_blank"
      rel="noreferrer"
      href={url}
    >
      {icon}
    </a>
  ) : (
    "-"
  );

/** صورة مصغّرة داخل خلية الجدول */
export const thumbnail = (src, alt = "") =>
  src ? (
    <img
      src={src}
      alt={alt}
      className="table-thumb rounded"
      loading="lazy"
    />
  ) : (
    "-"
  );

/** مفتاح تفعيل/إيقاف داخل خلية الجدول */
export const toggle = (checked, onChange, disabled = false) => (
  <Switch checked={!!checked} onChange={onChange} disabled={disabled} />
);

/** وسم ملوّن لحالة نصية */
export const statusTag = (label, color = "default") =>
  label ? <Tag color={color}>{label}</Tag> : "-";

/** نص "نعم/لا" للتصدير بدل true/false */
export const yesNo = (value) => (value ? "نعم" : "لا");
